module.exports = __webpack_public_path__ + "img/31.4acc754d.jpg";